import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=fd6fa9fc&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=fd6fa9fc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6fa9fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd6fa9fc')) {
      api.createRecord('fd6fa9fc', component.options)
    } else {
      api.reload('fd6fa9fc', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=fd6fa9fc&scoped=true&", function () {
      api.rerender('fd6fa9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jogBczsfJJH/JS/comp/Paginate.vue"
export default component.exports